import {
  Alert_default,
  Card_default,
  ErrorCodes,
  FormDivider_default,
  FormItemContainer_default,
  FormItemSmallLabelWithNoMargin,
  FormItemStatic_default,
  FormItem_default,
  InputLarge_default,
  Loader_default,
  ProductType,
  confirmValidator,
  emailValidator,
  get,
  getConfig,
  globalTranslate_default,
  ibanNumberValidator,
  phoneNumberCharacterValidator,
  phoneNumberLengthValidator,
  post,
  swrConfig,
  useNumber_default,
  zipCodeValidator
} from "./chunk-CLVK2PMJ.js";
import "./chunk-ZKQADMJN.js";
import {
  BorderInnerOutlined_default,
  BorderLeftOutlined_default,
  BorderOuterOutlined_default,
  BulbOutlined_default,
  EuroCircleOutlined_default,
  FireOutlined_default,
  FundOutlined_default,
  MailOutlined_default,
  MinusOutlined_default,
  PhoneOutlined_default,
  ThunderboltOutlined_default
} from "./chunk-W5IFUZB5.js";
import {
  affix_default,
  alert_default,
  button_default,
  checkbox_default,
  col_default,
  date_picker_default,
  form_default,
  init_moment,
  list_default,
  modal_default,
  moment_default,
  notification_default,
  radio_default,
  require_debounce,
  row_default,
  select_default,
  space_default,
  spin_default,
  typography_default
} from "./chunk-KX4LJVNT.js";
import {
  CalendarOutlined_default,
  CheckCircleOutlined_default,
  CheckOutlined_default,
  PlusOutlined_default
} from "./chunk-Z6O4S4Q7.js";
import "./chunk-2JWEPRN7.js";
import "./chunk-JYAP7RUW.js";
import {
  useSWR
} from "./chunk-LH4NQF7Z.js";
import {
  styled_components_browser_esm_default
} from "./chunk-OMPJY3VL.js";
import "./chunk-FDUCPDRR.js";
import "./chunk-KWUZEEQS.js";
import "./chunk-WGLPVN3I.js";
import "./chunk-YYUH7W7R.js";
import "./chunk-RDM77AGB.js";
import "./chunk-PUGBPE4F.js";
import {
  require_react
} from "./chunk-BODSDBIB.js";
import "./chunk-5G5NRCK2.js";
import "./chunk-3N3MIKLS.js";
import "./chunk-U3RDFDRR.js";
import {
  __toESM
} from "./chunk-TFWDKVI3.js";

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/index.js
var import_react16 = __toESM(require_react());

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/ApplyForm.js
init_moment();
var import_react = __toESM(require_react());

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/translations/en.js
var en = {
  calculateYourOffer: "Calculate your offer",
  number: "Number",
  addition: "Addition",
  zipCode: "Zip code",
  haveSmartMeter: "Do you have a smart meter?",
  calculate: "Calculate",
  enterData: "Enter data",
  validationIban: "Value is not in a valid IBAN format.",
  validationPhone: "Phone number must be between 10 and 13 characters.",
  validationPhoneOnlyNumber: "Phone number must contain only numbers or special characters.",
  extraPhone: "Phone number format must be in one of the following formats: +3112345678, 0612345678",
  next: "Next",
  back: "Back",
  knowConsumption: "I know my consumption",
  estimateConsumption: "Help me with estimates",
  person: "person",
  people: "people",
  numberOfPeople: "Number of people",
  power: "Energy",
  gas: "Gas",
  generateOwnEnergy: "I generate my own energy",
  yourEnergyConsumption: "Your energy consumption",
  livingSituation: "What does your living situation look like?",
  wantToSwitch: "I want to switch",
  wantToMove: "I have moved / am going to move",
  switchOrMove: "Do you want to switch or have you moved / are you going to move?",
  startDate: "When do you want to start the delivery?",
  personalInfo: "Your personal information",
  firstName: "First name",
  lastName: "Last name",
  birthdate: "Date of birth",
  email: "E-mail address",
  emailRepeat: "Repeat e-mail address",
  phone: "Phone number",
  paymentObligation: "Your monthly payment",
  iban: "IBAN",
  agreement: "Your agreement",
  permissionToSmartMeter: "I give permission to read my smart meter",
  termsAndConditions: "I agree to the general terms and conditions of delivery and the additional terms and conditions.",
  promotions: "Notify me of promotions, news and savings tips by email",
  solarPanel: "Solar panel",
  solarPanels: "Solar panels",
  numberOfSolarPanels: "Number of solar panels",
  extraBirthdate: "Birthdate format must be in the following format: 2022-02-02",
  ean: "EAN",
  homeOrWorkAddress: "Is this a home or work address?",
  information: "Information",
  smartMeterInformation: "If you register with Ecedo without a smart meter, we will have to offer you a model contract with fixed prices. This is a more expensive contract.",
  homeOrWorkAddressInformation: "In your situation you are not entitled to a reduction of your energy tax, amounting to € 824.76 (incl. VAT) per year.",
  startDateInformation: "437 / 5,000\nTranslation results\nTo be sure, check the end date of your current contract. If you have a contract for an indefinite period (variable contract), you can cancel immediately and you only have to take your notice period (often 30 days) into account. With a permanent contract, you keep the end date of that contract. In principle, it is not possible to start the contract earlier than 20 days. This has to do with the legal right of withdrawal. ",
  revival: "Revival",
  warning: "Warning",
  multipleEANWarning: "You have multiple EANs at this address. Contact us to continue the process!",
  contuctUs: "Neem contact op",
  yourPersonalOffer: "Your personal offer",
  youCanLeaveAnyTime: "You can leave whenever you want, without penalty!",
  averagePerMonth: "Average per month",
  expectedCostsPerYear: "Expected costs per year",
  avg: "avg.",
  priceStructureAndCosts: "Price structure and costs",
  highEnergyGeneration: "High energy generation may show you are a provider. Please contuct us!",
  lengthOfContract: "How many years would you like to sign this contract?",
  signedUpSuccess: "You signed up successfully!",
  createNew: "Create new offer",
  houseType1: "House Type 1",
  houseType2: "House Type 2",
  houseType3: "House Type 3"
};
var en_default = en;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/translations/nl.js
var nl = {
  calculateYourOffer: "Bereken je aanbod",
  number: "Nummer",
  addition: "Toevoeging",
  zipCode: "Postcode",
  haveSmartMeter: "Heb je een slimme meter?",
  calculate: "Bereken",
  enterData: "Gegevens invullen",
  validationIban: "Waarde heeft geen geldige IBAN-indeling.",
  validationPhone: "Telefoonnummer moet tussen de 10 en 13 tekens lang zijn.",
  validationPhoneOnlyNumber: "Telefoonnummer mag alleen cijfers bevatten.",
  extraPhone: "Het telefoonnummerformaat moet een van de volgende formaten hebben: +3112345678, 0612345678",
  next: "Volgende",
  back: "Vorig",
  knowConsumption: "Ik weet mijn verbruik",
  estimateConsumption: "Help me met schatten",
  person: "persoon",
  people: "personen",
  numberOfPeople: "Aantal personen",
  power: "Stroom",
  gas: "Gas",
  generateOwnEnergy: "Ik wek zelf energie op",
  yourEnergyConsumption: "Je energieverbruik",
  livingSituation: "Hoe ziet je woonsituatie eruit?",
  wantToSwitch: "Ik wil overstappen",
  wantToMove: "Ik ben verhuisd / ga verhuizen",
  switchOrMove: "Wil je overstappen of ben je verhuisd/ga je verhuizen?",
  startDate: "Wanneer wil je de levering starten?",
  personalInfo: "Je persoonlijke gegevens",
  firstName: "Voornaam",
  lastName: "Achternaam",
  birthdate: "Geboortedatum",
  email: "E-mailadres",
  emailRepeat: "E-mailadres herhalen",
  phone: "Telefoonnummer",
  paymentObligation: "Je maandelijkse betaling",
  iban: "IBAN",
  agreement: "Je akkoord",
  permissionToSmartMeter: "Ik geef toestemming om mijn slimme meter uit te lezen",
  termsAndConditions: "Ik ga akkoord met de algemene leveringsvoorwaarden en de aanvullende voorwaarden.",
  promotions: "Houd me op de hoogte van acties, nieuws en besparingstips via e-mail",
  solarPanel: "Zonnepaneel",
  solarPanels: "Zonnepanelen",
  numberOfSolarPanels: "Aantal zonnepanelen",
  extraBirthdate: "Het geboortedatumformaat moet het volgende formaat hebben: 2022-02-02",
  ean: "EAN",
  homeOrWorkAddress: "Is dit een woon- of werkadres?",
  information: "Informatie",
  smartMeterInformation: "Als je je zonder slimme meter aanmeldt bij Ecedo, zullen we je een modelcontract met vaste prijzen moeten aanbieden. Dit is een duurder contract.",
  homeOrWorkAddressInformation: "In jouw situatie heb je geen recht op vermindering van je energiebelasting, ter hoogte van € 824,76 (incl. BTW) per jaar.",
  startDateInformation: "Check voor de zekerheid de einddatum van je huidige contract. Als je een contract voor onbepaalde tijd hebt (variabel contract) kan je direct opzeggen en hoef je alleen maar rekening te houden met je opzegtermijn (vaak 30 dagen). Bij een vast contract houd je de einddatum aan van dat contract. Het is in principe niet mogelijk om het contract eerder in te laten gaan dan 20 dagen. Dit heeft te maken met het wettelijke herroepingsrecht.",
  revival: "Opwekking",
  warning: "Waarschuwing",
  multipleEANWarning: "U heeft meerdere EAN's op dit adres. Neem contact met ons op om het proces voort te zetten!",
  contuctUs: "Contuct Us",
  yourPersonalOffer: "Je persoonlijk aanbod",
  youCanLeaveAnyTime: "Je kunt weg wanneer je wilt, zonder boete!",
  averagePerMonth: "Gemiddeld per maand",
  expectedCostsPerYear: "Verwachte kosten per jaar",
  avg: "gem.",
  priceStructureAndCosts: "Prijsopbouw en kosten",
  highEnergyGeneration: "Hoge energieopwekking kan aantonen dat u een leverancier bent. Gelieve ons te contacteren!",
  lengthOfContract: "Voor hoeveel jaar wilt u dit contract tekenen?",
  signedUpSuccess: "Je hebt je succesvol aangemeld!",
  createNew: "Nieuwe aanbieding maken",
  houseType1: "Huis Type 1",
  houseType2: "Huis Type 2",
  houseType3: "Huis Type 3"
};
var nl_default = nl;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/translations/index.js
var __assign = function() {
  __assign = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var _a;
var _b;
var _c;
var _d;
var _e;
var _f;
var brandEn = ((_c = (_b = (_a = window.brandConfig) === null || _a === void 0 ? void 0 : _a.translations) === null || _b === void 0 ? void 0 : _b.signUpFlow) === null || _c === void 0 ? void 0 : _c.en) || {};
var brandNl = ((_f = (_e = (_d = window.brandConfig) === null || _d === void 0 ? void 0 : _d.translations) === null || _e === void 0 ? void 0 : _e.signUpFlow) === null || _f === void 0 ? void 0 : _f.nl) || {};
var localTranslations = {
  en: __assign(__assign({}, en_default), brandEn),
  nl: __assign(__assign({}, nl_default), brandNl)
};
var translations = {
  en: __assign(__assign({}, globalTranslate_default.en), localTranslations.en),
  nl: __assign(__assign({}, globalTranslate_default.nl), localTranslations.nl)
};

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/FormItemContainerMarginFix.js
var __makeTemplateObject = function(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", { value: raw });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var FormItemContainerMarginFix = styled_components_browser_esm_default(FormItemContainer_default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 16px -12px 0;\n  padding: 0;\n  max-width: 691px;\n"], ["\n  margin: 16px -12px 0;\n  padding: 0;\n  max-width: 691px;\n"])));
var FormItemContainerMarginFix_default = FormItemContainerMarginFix;
var templateObject_1;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/SectionContainer.js
var __makeTemplateObject2 = function(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", { value: raw });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var SectionContainer = styled_components_browser_esm_default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject2(["\n  margin-top: 16px;\n"], ["\n  margin-top: 16px;\n"])));
var SectionContainer_default = SectionContainer;
var templateObject_12;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/SectionTitle.js
var __makeTemplateObject3 = function(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", { value: raw });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var SectionTitle = styled_components_browser_esm_default.h2(templateObject_13 || (templateObject_13 = __makeTemplateObject3(["\n  font-size: 21px;\n  font-weight: bold;\n"], ["\n  font-size: 21px;\n  font-weight: bold;\n"])));
var SectionTitle_default = SectionTitle;
var templateObject_13;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/SignUpFlowAlertContainer.js
var __makeTemplateObject4 = function(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", { value: raw });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var SingUpFlowAlertContainer = styled_components_browser_esm_default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject4(["\n  max-width: 667px;\n"], ["\n  max-width: 667px;\n"])));
var SignUpFlowAlertContainer_default = SingUpFlowAlertContainer;
var templateObject_14;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/ApplyForm.js
var ApplyForm = function(_a2) {
  var form = _a2.form, language = _a2.language;
  var switchOrMoveOptions = (0, import_react.useMemo)(function() {
    return [
      {
        label: translations[language].wantToSwitch,
        value: true
      },
      {
        label: translations[language].wantToMove,
        value: false
      }
    ];
  }, [language]);
  return import_react.default.createElement(
    form_default,
    { form, labelCol: { span: 24 }, wrapperCol: { span: 24 }, initialValues: {
      switchOrMove: true,
      startDate: moment_default()
    }, validateMessages: {
      // eslint-disable-next-line no-template-curly-in-string
      required: translations[language].validationRequired
    } },
    import_react.default.createElement(
      FormItem_default,
      { label: translations[language].switchOrMove, name: "switchOrMove" },
      import_react.default.createElement(radio_default.Group, { size: "large", options: switchOrMoveOptions, optionType: "button" })
    ),
    import_react.default.createElement(FormDivider_default, null),
    import_react.default.createElement(
      FormItem_default,
      { label: translations[language].startDate, name: "startDate" },
      import_react.default.createElement(date_picker_default, { size: "large" })
    ),
    import_react.default.createElement(
      SectionContainer_default,
      null,
      import_react.default.createElement(
        SignUpFlowAlertContainer_default,
        null,
        import_react.default.createElement(alert_default, { message: translations[language].information, description: translations[language].startDateInformation, type: "info", showIcon: true })
      )
    ),
    import_react.default.createElement(FormDivider_default, null),
    import_react.default.createElement(SectionTitle_default, null, translations[language].personalInfo),
    import_react.default.createElement(
      FormItemContainerMarginFix_default,
      null,
      import_react.default.createElement(
        "div",
        { className: "form-item-col form-item-col-50" },
        import_react.default.createElement(
          FormItemSmallLabelWithNoMargin,
          { label: translations[language].firstName, name: "firstName", rules: [{ required: true }] },
          import_react.default.createElement(InputLarge_default, { placeholder: translations[language].firstName })
        )
      ),
      import_react.default.createElement(
        "div",
        { className: "form-item-col form-item-col-50" },
        import_react.default.createElement(
          FormItemSmallLabelWithNoMargin,
          { label: translations[language].lastName, name: "lastName", rules: [{ required: true }] },
          import_react.default.createElement(InputLarge_default, { placeholder: translations[language].lastName })
        )
      ),
      import_react.default.createElement(
        "div",
        { className: "form-item-col form-item-col-full" },
        import_react.default.createElement(
          FormItemSmallLabelWithNoMargin,
          { label: translations[language].birthdate, name: "birthdate", extra: translations[language].extraBirthdate, rules: [{ required: true }] },
          import_react.default.createElement(InputLarge_default, { placeholder: translations[language].birthdate, prefix: import_react.default.createElement(CalendarOutlined_default, null) })
        )
      ),
      import_react.default.createElement(
        "div",
        { className: "form-item-col form-item-col-50" },
        import_react.default.createElement(
          FormItemSmallLabelWithNoMargin,
          { label: translations[language].email, name: "email", rules: [{ required: true }, { validator: emailValidator(translations[language].validationEmail) }] },
          import_react.default.createElement(InputLarge_default, { placeholder: translations[language].email, prefix: import_react.default.createElement(MailOutlined_default, null) })
        )
      ),
      import_react.default.createElement(
        "div",
        { className: "form-item-col form-item-col-50" },
        import_react.default.createElement(
          FormItemSmallLabelWithNoMargin,
          { label: translations[language].emailRepeat, name: "emailConfirm", rules: [
            { required: true },
            function(_a3) {
              var getFieldValue = _a3.getFieldValue;
              return {
                validator: confirmValidator(translations[language].confirmValidationEmail, getFieldValue("email"))
              };
            }
          ] },
          import_react.default.createElement(InputLarge_default, { placeholder: translations[language].emailRepeat, prefix: import_react.default.createElement(MailOutlined_default, null) })
        )
      ),
      import_react.default.createElement(
        "div",
        { className: "form-item-col form-item-col-full" },
        import_react.default.createElement(
          FormItemSmallLabelWithNoMargin,
          { label: translations[language].phone, name: "phone", extra: translations[language].extraPhone, rules: [
            { required: true },
            {
              validator: phoneNumberLengthValidator(translations[language].validationPhone)
            },
            { validator: phoneNumberCharacterValidator(translations[language].validationPhoneOnlyNumber) }
          ] },
          import_react.default.createElement(InputLarge_default, { placeholder: translations[language].phone, prefix: import_react.default.createElement(PhoneOutlined_default, null) })
        )
      )
    ),
    import_react.default.createElement(FormDivider_default, null),
    import_react.default.createElement(SectionTitle_default, null, translations[language].paymentObligation),
    import_react.default.createElement(
      FormItemContainerMarginFix_default,
      null,
      import_react.default.createElement(
        "div",
        { className: "form-item-col form-item-col-full" },
        import_react.default.createElement(
          FormItemSmallLabelWithNoMargin,
          { label: translations[language].iban, name: "iban", extra: "We gebruiken je rekeningnummer alleen voor de afschrijving van je maandbedrag.", rules: [{ required: true }, { validator: ibanNumberValidator(translations[language].validationIban) }] },
          import_react.default.createElement(InputLarge_default, { placeholder: translations[language].iban })
        )
      )
    ),
    import_react.default.createElement(FormDivider_default, null),
    import_react.default.createElement(SectionTitle_default, null, translations[language].agreement),
    import_react.default.createElement(
      FormItemContainerMarginFix_default,
      null,
      import_react.default.createElement(
        "div",
        { className: "form-item-col form-item-col-full" },
        import_react.default.createElement(
          FormItemSmallLabelWithNoMargin,
          { name: "permissionToSmartReader", valuePropName: "checked" },
          import_react.default.createElement(checkbox_default, null, translations[language].permissionToSmartMeter)
        )
      ),
      import_react.default.createElement(
        "div",
        { className: "form-item-col form-item-col-full" },
        import_react.default.createElement(
          FormItemSmallLabelWithNoMargin,
          { name: "termsAndConditions", valuePropName: "checked" },
          import_react.default.createElement(checkbox_default, null, translations[language].termsAndConditions)
        )
      ),
      import_react.default.createElement(
        "div",
        { className: "form-item-col form-item-col-full" },
        import_react.default.createElement(
          FormItemSmallLabelWithNoMargin,
          { name: "promotions", valuePropName: "checked" },
          import_react.default.createElement(checkbox_default, null, translations[language].promotions)
        )
      )
    )
  );
};
var ApplyForm_default = ApplyForm;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/OfferForm.js
var import_react9 = __toESM(require_react());

// node_modules/@myportal/ecedo-myportal-frontend-components/hooks/useDebounce.js
var import_debounce = __toESM(require_debounce());
var import_react2 = __toESM(require_react());
var useDebounce = function(_a2) {
  var callback = _a2.callback;
  var handleDebouncedChange = (0, import_debounce.default)(function(value) {
    callback(value);
  }, 500);
  (0, import_react2.useEffect)(function() {
    return function() {
      handleDebouncedChange.cancel();
    };
  }, [handleDebouncedChange]);
  var handleInputChange = (0, import_react2.useCallback)(function(e) {
    handleDebouncedChange(e.target.value);
  }, [handleDebouncedChange]);
  return { handleInputChange };
};
var useDebounce_default = useDebounce;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/service/index.js
var __awaiter = function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var getAccessToken = function(url) {
  return __awaiter(void 0, void 0, void 0, function() {
    var response;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, getConfig({ url })];
        case 1:
          response = _a2.sent();
          if (response === null || response === void 0 ? void 0 : response.isError) {
            throw new Error(ErrorCodes.E500);
          }
          return [2, response];
      }
    });
  });
};
var getBrandSummaryJson = function(url) {
  return getConfig({ url });
};
var getAddresses = function(token, url) {
  return get({ url, token });
};
var getContractLengthOptions = function(token) {
  return function(url) {
    return get({ url, token });
  };
};
var getCalculation = function(token, url) {
  return get({ url, token });
};
var postSignUp = function(token, url, value) {
  return post({ url, token, value });
};

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/hooks/useContractLengthData.js
var useContractLengthData = function(_a2) {
  var baseUrl = _a2.baseUrl, token = _a2.token;
  var _b2 = useSWR(token ? "".concat(baseUrl, "/api/signup/contract") : null, getContractLengthOptions(token), swrConfig), data = _b2.data, error = _b2.error;
  return {
    data,
    error,
    pending: !data && !error
  };
};
var useContractLengthData_default = useContractLengthData;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/hooks/useSignUpAddress.js
var import_react3 = __toESM(require_react());

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/utils/index.js
init_moment();
var __awaiter2 = function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator2 = function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var checkMultipleEans = function(eans) {
  return !Array.isArray(eans) || eans.length <= 0 || eans.length > 2 || eans.filter(function(item) {
    return item.energyProduct === "Electricity";
  }).length >= 2 || eans.filter(function(item) {
    return item.energyProduct === "Gas";
  }).length >= 2;
};
var hash = function(text, salt) {
  if (text === void 0) {
    text = moment_default().format("YYYY-MM-DD HH:mm");
  }
  if (salt === void 0) {
    salt = 'Z_I@5c*blV,nu4>xW."c2OA%/<Sv&VX)';
  }
  return __awaiter2(void 0, void 0, void 0, function() {
    var utf8, hashBuffer, hashArray;
    return __generator2(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          utf8 = new TextEncoder().encode(salt ? text + salt : text);
          return [4, crypto.subtle.digest("SHA-256", utf8)];
        case 1:
          hashBuffer = _a2.sent();
          hashArray = Array.from(new Uint8Array(hashBuffer));
          return [2, hashArray.map(function(bytes) {
            return bytes.toString(16).padStart(2, "0");
          }).join("")];
      }
    });
  });
};

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/hooks/useSignUpAddress.js
var __awaiter3 = function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator3 = function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var useSignUpAddress = function(_a2) {
  var baseUrl = _a2.baseUrl, token = _a2.token, form = _a2.form, setAddress = _a2.setAddress, setAddressPending = _a2.setAddressPending, setDisabled = _a2.setDisabled, setMultipleEAN = _a2.setMultipleEAN, setEans = _a2.setEans;
  var checkAddress = (0, import_react3.useCallback)(function() {
    return __awaiter3(void 0, void 0, void 0, function() {
      var zipCode, number, addition, address, e_1;
      return __generator3(this, function(_a3) {
        switch (_a3.label) {
          case 0:
            _a3.trys.push([0, 2, 3, 4]);
            zipCode = form.getFieldValue("zipCode");
            number = form.getFieldValue("number");
            addition = form.getFieldValue("addition");
            if (!zipCode || !number) {
              setAddress(null);
              setDisabled(true);
              return [
                2
                /*return*/
              ];
            }
            setAddressPending(true);
            return [4, getAddresses(token, "".concat(baseUrl, "/api/signup/search?zipCode=").concat(zipCode, "&number=").concat(number, "&addition=").concat(addition))];
          case 1:
            address = _a3.sent();
            if (checkMultipleEans(address.eans)) {
              setMultipleEAN(true);
            } else {
              setMultipleEAN(false);
              setDisabled(false);
            }
            setEans(address.eans);
            setAddress("".concat(address.street, " ").concat(address.number).concat(address.addition || "", ", ").concat(address.zipCode, " ").concat(address.city));
            return [3, 4];
          case 2:
            e_1 = _a3.sent();
            console.error(e_1);
            return [3, 4];
          case 3:
            setAddressPending(false);
            return [
              7
              /*endfinally*/
            ];
          case 4:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, [baseUrl, token, form, setAddress, setAddressPending, setDisabled, setMultipleEAN, setEans]);
  return {
    checkAddress
  };
};
var useSignUpAddress_default = useSignUpAddress;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/AddressSection.js
var import_react4 = __toESM(require_react());
var AddressSection = function(_a2) {
  var address = _a2.address, addressPending = _a2.addressPending, addressChange = _a2.addressChange, language = _a2.language, _b2 = _a2.disabled, disabled = _b2 === void 0 ? false : _b2;
  return import_react4.default.createElement(
    import_react4.default.Fragment,
    null,
    import_react4.default.createElement(
      FormItemContainerMarginFix_default,
      null,
      import_react4.default.createElement(
        "div",
        { className: "form-item-col form-item-col-lg" },
        import_react4.default.createElement(
          FormItemSmallLabelWithNoMargin,
          { label: translations[language].zipCode, name: "zipCode", rules: [{ required: true }, { validator: zipCodeValidator(translations[language].validationZipCode) }] },
          import_react4.default.createElement(InputLarge_default, { placeholder: translations[language].zipCode, onChange: addressChange, disabled })
        )
      ),
      import_react4.default.createElement(
        "div",
        { className: "form-item-col form-item-col-lg" },
        import_react4.default.createElement(
          FormItemSmallLabelWithNoMargin,
          { label: translations[language].number, name: "number", rules: [{ required: true }] },
          import_react4.default.createElement(InputLarge_default, { placeholder: translations[language].number, onChange: addressChange, disabled })
        )
      ),
      import_react4.default.createElement(
        "div",
        { className: "form-item-col form-item-col-lg" },
        import_react4.default.createElement(
          FormItemSmallLabelWithNoMargin,
          { label: translations[language].addition, name: "addition" },
          import_react4.default.createElement(InputLarge_default, { placeholder: translations[language].addition, onChange: addressChange, disabled })
        )
      )
    ),
    addressPending && import_react4.default.createElement(
      SignUpFlowAlertContainer_default,
      null,
      import_react4.default.createElement(Loader_default, { small: true })
    ),
    address && !addressPending && import_react4.default.createElement(
      SignUpFlowAlertContainer_default,
      null,
      import_react4.default.createElement(alert_default, { message: address, type: "info" })
    )
  );
};
var AddressSection_default = AddressSection;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/ConsumptionForm.js
var import_react6 = __toESM(require_react());

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/ConsumptionHelpSection.js
var import_react5 = __toESM(require_react());

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/BlueCard.js
var __makeTemplateObject5 = function(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", { value: raw });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var BlueCard = styled_components_browser_esm_default(Card_default)(templateObject_15 || (templateObject_15 = __makeTemplateObject5(["\n  max-width: 667px;\n  background-color: #e6f7ff;\n  border: 1px solid #91d5ff;\n"], ["\n  max-width: 667px;\n  background-color: #e6f7ff;\n  border: 1px solid #91d5ff;\n"])));
var BlueCard_default = BlueCard;
var templateObject_15;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/BlueCardTitle.js
var __makeTemplateObject6 = function(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", { value: raw });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var BlueCardTitle = styled_components_browser_esm_default.h3(templateObject_16 || (templateObject_16 = __makeTemplateObject6(["\n  font-size: 12px;\n  font-weight: bold;\n  text-transform: uppercase;\n"], ["\n  font-size: 12px;\n  font-weight: bold;\n  text-transform: uppercase;\n"])));
var BlueCardTitle_default = BlueCardTitle;
var templateObject_16;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/ConsumptionHelpSection.js
var ConsumptionHelpSection = function(_a2) {
  var form = _a2.form, disabled = _a2.disabled, language = _a2.language;
  var energyConsumptionOptions = (0, import_react5.useMemo)(function() {
    return [
      {
        label: translations[language].knowConsumption,
        value: true
      },
      {
        label: translations[language].estimateConsumption,
        value: false
      }
    ];
  }, [language]);
  var numberOfPersonOptions = (0, import_react5.useMemo)(function() {
    return [1750, 2750, 3650, 4450, 5100];
  }, []);
  var numberOfGenerateOptions = (0, import_react5.useMemo)(function() {
    return [250, 500, 750, 1e3, 1250];
  }, []);
  var housingTypeOptions = (0, import_react5.useMemo)(function() {
    return [
      {
        label: import_react5.default.createElement(
          import_react5.default.Fragment,
          null,
          import_react5.default.createElement(BorderLeftOutlined_default, null),
          " ",
          translations[language].houseType1
        ),
        value: 1
      },
      {
        label: import_react5.default.createElement(
          import_react5.default.Fragment,
          null,
          import_react5.default.createElement(BorderInnerOutlined_default, null),
          " ",
          translations[language].houseType2
        ),
        value: 2
      },
      {
        label: import_react5.default.createElement(
          import_react5.default.Fragment,
          null,
          import_react5.default.createElement(BorderOuterOutlined_default, null),
          " ",
          translations[language].houseType3
        ),
        value: 3
      }
    ];
  }, [language]);
  return import_react5.default.createElement(
    import_react5.default.Fragment,
    null,
    import_react5.default.createElement(
      FormItem_default,
      { label: translations[language].yourEnergyConsumption, name: "energyConsumption" },
      import_react5.default.createElement(radio_default.Group, { size: "large", options: energyConsumptionOptions, optionType: "button", disabled })
    ),
    import_react5.default.createElement(FormItem_default, { shouldUpdate: true, noStyle: true }, function(_a3) {
      var getFieldValue = _a3.getFieldValue;
      return !getFieldValue("energyConsumption") ? import_react5.default.createElement(
        SectionContainer_default,
        null,
        import_react5.default.createElement(
          BlueCard_default,
          null,
          import_react5.default.createElement(BlueCardTitle_default, null, translations[language].livingSituation),
          import_react5.default.createElement(
            FormItemContainerMarginFix_default,
            null,
            import_react5.default.createElement(FormItem_default, { shouldUpdate: true, noStyle: true }, function(_a4) {
              var getFieldValue2 = _a4.getFieldValue;
              var value = parseInt(getFieldValue2("generateEnergyHelp")) >= 0 ? parseInt(getFieldValue2("generateEnergyHelp")) : 0;
              return value * numberOfGenerateOptions[0] >= 1e4 ? import_react5.default.createElement(
                "div",
                { className: "form-item-col form-item-col-full" },
                import_react5.default.createElement(alert_default, { message: translations[language].warning, description: translations[language].highEnergyGeneration, type: "warning", showIcon: true })
              ) : null;
            }),
            import_react5.default.createElement(
              "div",
              { className: "form-item-col form-item-col-50" },
              import_react5.default.createElement(
                FormItemSmallLabelWithNoMargin,
                { name: "consumptionHelp" },
                import_react5.default.createElement(select_default, { size: "large", placeholder: translations[language].numberOfPeople, onSelect: function(value) {
                  form.setFieldsValue({
                    consumptionOfEnergy: numberOfPersonOptions[value],
                    consumptionOfGas: numberOfGenerateOptions[value]
                  });
                } }, numberOfPersonOptions.map(function(item, index) {
                  return import_react5.default.createElement(select_default.Option, { value: index, key: item }, index === 0 ? "".concat(index + 1, " ").concat(translations[language].person) : "".concat(index + 1, " ").concat(translations[language].people));
                }))
              )
            ),
            import_react5.default.createElement(FormItem_default, { shouldUpdate: true, noStyle: true }, function(_a4) {
              var getFieldValue2 = _a4.getFieldValue;
              return getFieldValue2("canGenerateEnergy") ? import_react5.default.createElement(
                "div",
                { className: "form-item-col form-item-col-50" },
                import_react5.default.createElement(
                  FormItemSmallLabelWithNoMargin,
                  { name: "generateEnergyHelp" },
                  import_react5.default.createElement(InputLarge_default, { placeholder: translations[language].numberOfSolarPanels, onChange: function(e) {
                    var value = parseInt(e.target.value) >= 0 ? parseInt(e.target.value) : 0;
                    form.setFieldsValue({ generatedEnergy: value * numberOfGenerateOptions[0] });
                  }, suffix: import_react5.default.createElement(BulbOutlined_default, null) })
                )
              ) : null;
            })
          ),
          import_react5.default.createElement(
            FormItemContainerMarginFix_default,
            null,
            import_react5.default.createElement(
              "div",
              { className: "form-item-col form-item-col-full" },
              import_react5.default.createElement(
                FormItem_default,
                { label: "Type woning", name: "housingType" },
                import_react5.default.createElement(radio_default.Group, { size: "large", options: housingTypeOptions, optionType: "button" })
              )
            )
          )
        )
      ) : null;
    })
  );
};
var ConsumptionHelpSection_default = ConsumptionHelpSection;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/ConsumptionForm.js
var ConsumptionForm = function(_a2) {
  var form = _a2.form, eans = _a2.eans, electricityInputChange = _a2.electricityInputChange, gasInputChange = _a2.gasInputChange, disabled = _a2.disabled, language = _a2.language;
  return import_react6.default.createElement(
    import_react6.default.Fragment,
    null,
    import_react6.default.createElement(ConsumptionHelpSection_default, { form, disabled, language }),
    import_react6.default.createElement(FormDivider_default, null),
    import_react6.default.createElement(FormItemContainerMarginFix_default, null, eans.map(function(item) {
      return import_react6.default.createElement(
        import_react6.Fragment,
        { key: item.ean },
        import_react6.default.createElement(
          form_default.Item,
          { name: item.energyProduct === "Electricity" ? "eanOfEnergy" : "eanOfGas", initialValue: item.ean, hidden: true },
          import_react6.default.createElement(InputLarge_default, null)
        ),
        import_react6.default.createElement(
          "div",
          { className: "form-item-col ".concat(eans.length === 1 ? "form-item-col-full" : "form-item-col-50") },
          import_react6.default.createElement(
            FormItemSmallLabelWithNoMargin,
            { label: item.energyProduct === "Electricity" ? translations[language].power : translations[language].gas, name: item.energyProduct === "Electricity" ? "consumptionOfEnergy" : "consumptionOfGas", rules: [{ required: true }] },
            import_react6.default.createElement(InputLarge_default, { placeholder: item.energyProduct === "Electricity" ? translations[language].power : translations[language].gas, prefix: item.energyProduct === "Electricity" ? import_react6.default.createElement(ThunderboltOutlined_default, null) : import_react6.default.createElement(FireOutlined_default, null), suffix: item.energyProduct === "Electricity" ? "kWh" : "m³", disabled, onChange: item.energyProduct === "Electricity" ? electricityInputChange : gasInputChange })
          )
        )
      );
    }))
  );
};
var ConsumptionForm_default = ConsumptionForm;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/ConsumptionMultipleForm.js
var import_react7 = __toESM(require_react());
var __read = function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
      ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"]))
        m.call(i);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var __spreadArray = function(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var ConsumptionMultipleForm = function(_a2) {
  var form = _a2.form, selectedEANList = _a2.selectedEANList, setSelectedEANList = _a2.setSelectedEANList, language = _a2.language;
  var eanOptions = (0, import_react7.useMemo)(function() {
    return [
      {
        name: "Electricity",
        eans: ["871687460011276891", "871689260011572737", "871692160011417820"]
      },
      {
        name: "Gas",
        eans: ["871687460011276892", "871689260011572738", "871692160011417821"]
      }
    ];
  }, []);
  return import_react7.default.createElement(
    import_react7.default.Fragment,
    null,
    import_react7.default.createElement(
      FormItemContainerMarginFix_default,
      null,
      import_react7.default.createElement(
        "div",
        { className: "form-item-col form-item-col-2/3" },
        import_react7.default.createElement(
          FormItemSmallLabelWithNoMargin,
          { name: "ean" },
          import_react7.default.createElement(select_default, { size: "large", placeholder: translations[language].ean }, eanOptions.map(function(group) {
            return import_react7.default.createElement(select_default.OptGroup, { key: group.name, label: group.name }, group.eans.filter(function(ean) {
              return !selectedEANList.find(function(item) {
                return item.ean === ean;
              });
            }).map(function(item) {
              return import_react7.default.createElement(select_default.Option, { key: item, value: item }, item);
            }));
          }))
        )
      ),
      import_react7.default.createElement(
        "div",
        { className: "form-item-col form-item-col-1/3" },
        import_react7.default.createElement(button_default, { type: "dashed", onClick: function() {
          var selectedEAN = form.getFieldValue("ean");
          if (selectedEAN) {
            setSelectedEANList(function(state) {
              var _a3;
              return __spreadArray(__spreadArray([], __read(state), false), [
                {
                  ean: form.getFieldValue("ean"),
                  type: ((_a3 = eanOptions.find(function(item) {
                    return item.eans.find(function(ean) {
                      return ean === form.getFieldValue("ean");
                    });
                  })) === null || _a3 === void 0 ? void 0 : _a3.name) || "Electricity",
                  value: 0
                }
              ], false);
            });
            form.setFieldsValue({ ean: null });
          }
        }, block: true, icon: import_react7.default.createElement(PlusOutlined_default, null), size: "large" }, "Add EAN")
      )
    ),
    import_react7.default.createElement(form_default.List, { name: "consumptions" }, function() {
      return selectedEANList.sort(function(a, b) {
        return a.type.localeCompare(b.type);
      }).map(function(selectedEAN, index) {
        return import_react7.default.createElement(
          FormItemContainerMarginFix_default,
          { key: index },
          import_react7.default.createElement(
            "div",
            { className: "form-item-col form-item-col-4/3" },
            import_react7.default.createElement(
              FormItemStatic_default,
              null,
              import_react7.default.createElement("span", { className: "static-label" }, translations[language].ean),
              selectedEAN.ean
            ),
            import_react7.default.createElement(
              FormItemSmallLabelWithNoMargin,
              { label: translations[language].ean, name: [index, "ean"], initialValue: selectedEAN.ean, hidden: true },
              import_react7.default.createElement(InputLarge_default, { placeholder: translations[language].ean, readOnly: true })
            )
          ),
          import_react7.default.createElement(
            "div",
            { className: "form-item-col form-item-col-4/3" },
            import_react7.default.createElement(
              FormItemSmallLabelWithNoMargin,
              { label: selectedEAN.type === ProductType.ELECTRICITY ? "Stroom" : "Gas", name: [index, selectedEAN.type === ProductType.ELECTRICITY ? "energy" : "gas"], initialValue: selectedEAN.value, rules: [{ required: true }] },
              import_react7.default.createElement(InputLarge_default, { placeholder: selectedEAN.type === ProductType.ELECTRICITY ? "Stroom" : "Gas", prefix: selectedEAN.type === ProductType.ELECTRICITY ? import_react7.default.createElement(ThunderboltOutlined_default, null) : import_react7.default.createElement(FireOutlined_default, null), suffix: selectedEAN.type === ProductType.ELECTRICITY ? "kWh" : "m³", onChange: function(e) {
                setSelectedEANList(function(state) {
                  var tempState = __spreadArray([], __read(state), false);
                  var index2 = state.findIndex(function(item) {
                    return item.ean === selectedEAN.ean;
                  });
                  tempState[index2].value = parseInt(e.target.value);
                  return tempState;
                });
              } })
            )
          ),
          import_react7.default.createElement(
            "div",
            { className: "form-item-col form-item-col-1/3" },
            import_react7.default.createElement(button_default, { type: "dashed", onClick: function() {
              setSelectedEANList(function(state) {
                return state.filter(function(item) {
                  return item.ean !== selectedEAN.ean;
                });
              });
            }, block: true, icon: import_react7.default.createElement(MinusOutlined_default, null), size: "large", danger: true }, "Remove")
          )
        );
      });
    })
  );
};
var ConsumptionMultipleForm_default = ConsumptionMultipleForm;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/ContactAlert.js
var import_react8 = __toESM(require_react());
var __makeTemplateObject7 = function(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", { value: raw });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var ContactSpace = styled_components_browser_esm_default(space_default)(templateObject_17 || (templateObject_17 = __makeTemplateObject7(["\n  width: 100%;\n  > .ant-space-item:nth-of-type(2) {\n    display: flex;\n    justify-content: center;\n  }\n"], ["\n  width: 100%;\n  > .ant-space-item:nth-of-type(2) {\n    display: flex;\n    justify-content: center;\n  }\n"])));
var ContactAlert = function(_a2) {
  var language = _a2.language;
  return import_react8.default.createElement(
    ContactSpace,
    { direction: "vertical" },
    import_react8.default.createElement(
      SignUpFlowAlertContainer_default,
      null,
      import_react8.default.createElement(alert_default, { message: translations[language].warning, description: translations[language].multipleEANWarning, type: "warning", showIcon: true })
    ),
    import_react8.default.createElement(button_default, { size: "large", href: "mailto:contuct@ecedo.nl", icon: import_react8.default.createElement(MailOutlined_default, null) }, translations[language].contuctUs)
  );
};
var ContactAlert_default = ContactAlert;
var templateObject_17;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/OfferForm.js
var OfferForm = function(_a2) {
  var baseUrl = _a2.baseUrl, _b2 = _a2.token, token = _b2 === void 0 ? "" : _b2, address = _a2.address, setAddress = _a2.setAddress, addressPending = _a2.addressPending, setAddressPending = _a2.setAddressPending, disabled = _a2.disabled, _c2 = _a2.disabledAddress, disabledAddress = _c2 === void 0 ? false : _c2, setDisabled = _a2.setDisabled, setElectricity = _a2.setElectricity, setGas = _a2.setGas, form = _a2.form, language = _a2.language, multipleEAN = _a2.multipleEAN, setMultipleEAN = _a2.setMultipleEAN, showMultipleEANForm = _a2.showMultipleEANForm, selectedEANList = _a2.selectedEANList, setSelectedEANList = _a2.setSelectedEANList, eans = _a2.eans, setEans = _a2.setEans;
  var electricityInputChange = useDebounce_default({ callback: setElectricity }).handleInputChange;
  var gasInputChange = useDebounce_default({ callback: setGas }).handleInputChange;
  var _d2 = useContractLengthData_default({ baseUrl, token }), data = _d2.data, pending = _d2.pending;
  var checkAddress = useSignUpAddress_default({
    baseUrl,
    token,
    form,
    setAddress,
    setAddressPending,
    setDisabled,
    setMultipleEAN,
    setEans
  }).checkAddress;
  var addressChange = useDebounce_default({ callback: checkAddress }).handleInputChange;
  var smartMeterOptions = (0, import_react9.useMemo)(function() {
    return [
      {
        label: translations[language].yes,
        value: true
      },
      {
        label: translations[language].no,
        value: false
      }
    ];
  }, [language]);
  var yearsOptions = (0, import_react9.useMemo)(function() {
    return data === null || data === void 0 ? void 0 : data.options.map(function(item) {
      return {
        label: "".concat(item, " ").concat(item === 1 ? translations[language].year : translations[language].years),
        value: item
      };
    });
  }, [language, data]);
  (0, import_react9.useEffect)(function() {
    if (data && !form.getFieldValue("lengthOfContract")) {
      form.setFieldsValue({ lengthOfContract: data.options[0] });
    }
  }, [form, data]);
  var addressTypeOptions = (0, import_react9.useMemo)(function() {
    return [
      {
        label: translations[language].yes,
        value: true
      },
      {
        label: translations[language].no,
        value: false
      }
    ];
  }, [language]);
  return import_react9.default.createElement(
    form_default,
    { form, labelCol: { span: 24 }, wrapperCol: { span: 24 }, initialValues: {
      smartMeter: true,
      energyConsumption: true,
      canGenerateEnergy: false,
      addressType: true
    }, validateMessages: {
      // eslint-disable-next-line no-template-curly-in-string
      required: translations[language].validationRequired
    } },
    import_react9.default.createElement(AddressSection_default, { address, addressPending, addressChange, language, disabled: disabledAddress }),
    import_react9.default.createElement(FormDivider_default, null),
    multipleEAN ? import_react9.default.createElement(ContactAlert_default, { language }) : import_react9.default.createElement(
      import_react9.default.Fragment,
      null,
      import_react9.default.createElement(
        FormItem_default,
        { label: translations[language].haveSmartMeter, name: "smartMeter" },
        import_react9.default.createElement(radio_default.Group, { size: "large", options: smartMeterOptions, optionType: "button", disabled })
      ),
      import_react9.default.createElement(FormItem_default, { shouldUpdate: true, noStyle: true }, function(_a3) {
        var getFieldValue = _a3.getFieldValue;
        return !getFieldValue("smartMeter") ? import_react9.default.createElement(
          SectionContainer_default,
          null,
          import_react9.default.createElement(
            SignUpFlowAlertContainer_default,
            null,
            import_react9.default.createElement(alert_default, { message: translations[language].information, description: translations[language].smartMeterInformation, type: "info", showIcon: true })
          )
        ) : null;
      }),
      import_react9.default.createElement(FormDivider_default, null),
      import_react9.default.createElement(
        FormItem_default,
        { label: translations[language].generateOwnEnergy, name: "canGenerateEnergy" },
        import_react9.default.createElement(radio_default.Group, { size: "large", options: smartMeterOptions, optionType: "button", disabled })
      ),
      import_react9.default.createElement(FormDivider_default, null),
      token && (pending ? import_react9.default.createElement(Loader_default, { small: true }) : import_react9.default.createElement(
        import_react9.default.Fragment,
        null,
        import_react9.default.createElement(
          FormItem_default,
          { label: translations[language].lengthOfContract, name: "lengthOfContract" },
          import_react9.default.createElement(radio_default.Group, { size: "large", options: yearsOptions, optionType: "button", disabled })
        ),
        import_react9.default.createElement(FormDivider_default, null)
      )),
      !showMultipleEANForm ? import_react9.default.createElement(ConsumptionForm_default, { form, eans, electricityInputChange, gasInputChange, disabled, language }) : import_react9.default.createElement(ConsumptionMultipleForm_default, { form, selectedEANList, setSelectedEANList, language }),
      import_react9.default.createElement(FormItem_default, { shouldUpdate: true, noStyle: true }, function(_a3) {
        var getFieldValue = _a3.getFieldValue;
        return getFieldValue("canGenerateEnergy") ? import_react9.default.createElement(
          FormItemContainerMarginFix_default,
          null,
          import_react9.default.createElement(
            "div",
            { className: "form-item-col form-item-col-full" },
            import_react9.default.createElement(
              FormItemSmallLabelWithNoMargin,
              { label: translations[language].revival, name: "generatedEnergy", rules: [{ required: true }] },
              import_react9.default.createElement(InputLarge_default, { placeholder: translations[language].revival, prefix: import_react9.default.createElement(BulbOutlined_default, null), suffix: "kWh" })
            )
          )
        ) : null;
      }),
      import_react9.default.createElement(FormDivider_default, null),
      import_react9.default.createElement(
        FormItem_default,
        { label: translations[language].homeOrWorkAddress, name: "addressType" },
        import_react9.default.createElement(radio_default.Group, { size: "large", options: addressTypeOptions, optionType: "button", disabled })
      ),
      import_react9.default.createElement(FormItem_default, { shouldUpdate: true, noStyle: true }, function(_a3) {
        var getFieldValue = _a3.getFieldValue;
        return typeof getFieldValue("addressType") !== "undefined" && !getFieldValue("addressType") ? import_react9.default.createElement(
          SectionContainer_default,
          null,
          import_react9.default.createElement(
            SignUpFlowAlertContainer_default,
            null,
            import_react9.default.createElement(alert_default, { message: translations[language].information, description: translations[language].homeOrWorkAddressInformation, type: "info", showIcon: true })
          )
        ) : null;
      })
    )
  );
};
var OfferForm_default = OfferForm;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/SVG.js
var import_react10 = __toESM(require_react());
var SuccessIcon = function() {
  return import_react10.default.createElement(
    "svg",
    { width: "717.67004", height: "430.74265", viewBox: "0 0 717.67004 430.74265" },
    import_react10.default.createElement("path", { d: "M361.25422,634.29461a2.80741,2.80741,0,0,1-2.03464-4.86593l.19237-.76477q-.038-.09187-.07644-.18358a7.53909,7.53909,0,0,0-13.90673.05168c-2.27452,5.4781-5.17037,10.96553-5.8834,16.7577a22.30336,22.30336,0,0,0,.39152,7.67061,89.4194,89.4194,0,0,1-8.13413-37.13874,86.307,86.307,0,0,1,.53535-9.62829q.44349-3.93128,1.23055-7.80653a90.45569,90.45569,0,0,1,17.93812-38.33731A24.07269,24.07269,0,0,0,361.5186,549.6621a18.36288,18.36288,0,0,0,1.67-5.0179c-.48739.06393-1.83779-7.3591-1.47018-7.81452-.67924-1.03071-1.895-1.54307-2.6368-2.54885-3.68944-5.00211-8.77254-4.12872-11.42613,2.66875-5.6687,2.861-5.72357,7.60578-2.24528,12.16916,2.2129,2.90325,2.517,6.83168,4.45862,9.93984-.1998.25572-.40756.50345-.6073.75916a91.04013,91.04013,0,0,0-9.50223,15.05379,37.84589,37.84589,0,0,0-2.25945-17.5787c-2.16268-5.21725-6.21632-9.61123-9.786-14.12153-4.2878-5.41757-13.08033-3.05324-13.83575,3.81438q-.011.09975-.02141.19942.79531.44866,1.55706.95247a3.808,3.808,0,0,1-1.53533,6.92992l-.07765.012a37.88983,37.88983,0,0,0,.99876,5.66515c-4.57949,17.71009,5.30731,24.16047,19.42432,24.45023.31164.15979.61531.31957.927.47144a92.9244,92.9244,0,0,0-5.00193,23.53931,88.13549,88.13549,0,0,0,.06392,14.23066l-.024-.16778a23.28917,23.28917,0,0,0-7.95036-13.44763c-6.11822-5.0259-14.76211-6.87666-21.36259-10.9165a4.37072,4.37072,0,0,0-6.69422,4.252q.01328.08819.027.17642a25.57886,25.57886,0,0,1,2.86848,1.38225q.79533.44877,1.55706.95247a3.80809,3.80809,0,0,1-1.53533,6.93l-.07772.01194c-.05591.008-.10387.016-.15972.024a37.92262,37.92262,0,0,0,6.97545,10.92265c2.86344,15.46021,15.16195,16.927,28.31753,12.42487h.008a92.89768,92.89768,0,0,0,6.24043,18.21782h22.2928c.08-.24769.15185-.50341.22379-.75114a25.32943,25.32943,0,0,1-6.16855-.36744c1.654-2.02958,3.308-4.07513,4.962-6.10463a1.38552,1.38552,0,0,0,.10388-.11987c.839-1.03867,1.68595-2.06946,2.52491-3.10816l.00045-.00127a37.1011,37.1011,0,0,0-1.08711-9.45126Z", transform: "translate(-240.82477 -224.27489)", fill: "#f2f2f2" }),
    import_react10.default.createElement("path", { d: "M826.87639,634.29461a2.80741,2.80741,0,0,0,2.03464-4.86593l-.19237-.76477q.038-.09187.07644-.18358a7.53909,7.53909,0,0,1,13.90673.05168c2.27452,5.4781,5.17037,10.96553,5.8834,16.7577a22.30336,22.30336,0,0,1-.39152,7.67061,89.4194,89.4194,0,0,0,8.13413-37.13874,86.307,86.307,0,0,0-.53535-9.62829q-.44349-3.93128-1.23055-7.80653a90.45569,90.45569,0,0,0-17.93812-38.33731A24.07267,24.07267,0,0,1,826.612,549.6621a18.36254,18.36254,0,0,1-1.67-5.0179c.48738.06393,1.83778-7.3591,1.47017-7.81452.67924-1.03071,1.895-1.54307,2.63681-2.54885,3.68943-5.00211,8.77253-4.12872,11.42612,2.66875,5.6687,2.861,5.72357,7.60578,2.24528,12.16916-2.2129,2.90325-2.51695,6.83168-4.45862,9.93984.1998.25572.40756.50345.6073.75916a91.04013,91.04013,0,0,1,9.50223,15.05379,37.84589,37.84589,0,0,1,2.25945-17.5787c2.16269-5.21725,6.21632-9.61123,9.786-14.12153,4.2878-5.41757,13.08033-3.05324,13.83575,3.81438q.011.09975.02142.19942-.79533.44866-1.55706.95247a3.808,3.808,0,0,0,1.53532,6.92992l.07765.012a37.88983,37.88983,0,0,1-.99876,5.66515c4.57949,17.71009-5.30731,24.16047-19.42432,24.45023-.31163.15979-.61531.31957-.92694.47144a92.92556,92.92556,0,0,1,5.00193,23.53931,88.13663,88.13663,0,0,1-.06393,14.23066l.024-.16778a23.28917,23.28917,0,0,1,7.95036-13.44763c6.11822-5.0259,14.76211-6.87666,21.36259-10.9165a4.37072,4.37072,0,0,1,6.69422,4.252q-.01328.08819-.027.17642a25.57816,25.57816,0,0,0-2.86849,1.38225q-.79533.44877-1.55706.95247a3.80809,3.80809,0,0,0,1.53533,6.93l.07772.01194c.05591.008.10387.016.15972.024a37.92262,37.92262,0,0,1-6.97545,10.92265c-2.86344,15.46021-15.162,16.927-28.31753,12.42487h-.008a92.897,92.897,0,0,1-6.24043,18.21782H827.435c-.08-.24769-.15184-.50341-.22379-.75114a25.32943,25.32943,0,0,0,6.16855-.36744c-1.654-2.02958-3.308-4.07513-4.962-6.10463a1.38552,1.38552,0,0,1-.10388-.11987c-.839-1.03867-1.686-2.06946-2.52491-3.10816l-.00045-.00127a37.1011,37.1011,0,0,1,1.08711-9.45126Z", transform: "translate(-240.82477 -224.27489)", fill: "#f2f2f2" }),
    import_react10.default.createElement("path", { d: "M386.895,653.69939h35.97354c6.1526-20.71624.03286-69.67537,8.14252-89.68646,15.55874-38.36872,35.43533-78.85282,72.53425-97.5874,15.84013-7.99951,33.11135-11.124,50.74951-10.95382,24.36562.231,49.41629,6.77167,72.35082,15.4399,9.38173,3.53784,18.67782,7.42815,27.93727,11.40364,34.885,14.99008,69.39075,31.31745,106.9055,35.73059,47.47141,5.5802,103.28488-15.65873,116.25051-61.407,9.89551-35.02544-7.92615-71.38816-26.6163-102.66918-18.69007-31.28094-39.58192-64.75027-36.16921-100.96711.01217-.12155.02441-.25533.0489-.37688,1.28432-13.00842,9.05145-22.3572,19.90108-28.35078H787.6643c-.62376,33.78536,18.92255,63.60722,36.51181,93.05238,18.69007,31.26885,36.51174,67.64374,26.6163,102.66918-12.9657,45.7361-120.32735-7.87608-167.79876-13.46852-13.40595-1.56828,7.88949,4.01192-4.8927,0-20.04785-6.28542-22.27039,51.36316-41.78,42.90159-12.14612-5.27634-24.30448-10.51617-36.62186-15.1724-5.10062-1.93306-10.31136-3.7445-15.58324-5.42222-.01224,0-.01224,0-.02448-.01217-35.39868-11.20908-74.11212-15.57362-106.8198.63221-.22017.10937-.45257.21882-.67281.3282-37.09884,18.72241-56.97543,59.2065-72.53425,97.57523C391.20889,559.077,393.231,620.24223,386.895,653.69939Z", transform: "translate(-240.82477 -224.27489)", fill: "#f2f2f2" }),
    import_react10.default.createElement("circle", { cx: "346.2124", cy: "263.14042", r: "165.22325", fill: "#fff" }),
    import_react10.default.createElement("path", { d: "M586.56531,653.69939C423.09348,657.4548,419.509,579.791,419.509,487.41469c0-92.37408,75.153-167.52705,167.52817-167.52705s167.52818,75.153,167.52818,167.52705C754.56531,579.791,678.94051,653.69939,586.56531,653.69939Zm.47182-329.202c-89.834,0-161.40566,73.0972-162.91848,162.91736-1.4071,83.544,87.34448,187.795,162.91846,162.91958,40.5282-44.63489,155.11224-92.70923,162.91852-162.91958C759.88244,398.132,676.87114,324.49734,587.03713,324.49734Z", transform: "translate(-240.82477 -224.27489)", fill: "#3f3d56" }),
    import_react10.default.createElement("path", { d: "M564.49731,573.40632a18.37348,18.37348,0,0,1-14.70157-7.353l-45.07543-60.10157a18.37838,18.37838,0,1,1,29.40612-22.0531l29.48989,39.31686,75.741-113.60995a18.37916,18.37916,0,0,1,30.58477,20.38984L579.79118,565.22166a18.38663,18.38663,0,0,1-14.78233,8.17868C564.83833,573.40333,564.66782,573.40632,564.49731,573.40632Z", transform: "translate(-240.82477 -224.27489)", fill: "#f2f2f2" }),
    import_react10.default.createElement("path", { d: "M240.82477,653.82754a1.18647,1.18647,0,0,0,1.19007,1.19h715.29a1.19,1.19,0,1,0,0-2.38h-715.29A1.18651,1.18651,0,0,0,240.82477,653.82754Z", transform: "translate(-240.82477 -224.27489)", fill: "#ccc" }),
    import_react10.default.createElement("polygon", { points: "451.72 417.887 442.046 417.887 437.444 380.57 451.723 380.571 451.72 417.887", fill: "#ffb6b6" }),
    import_react10.default.createElement("path", { d: "M692.88615,652.25464l-29.75045-.00112v-.37625a11.58034,11.58034,0,0,1,11.5797-11.57952h.00072l5.4343-4.12274,10.13921,4.12337,2.597.00009Z", transform: "translate(-240.82477 -224.27489)", fill: "#2f2e41" }),
    import_react10.default.createElement("polygon", { points: "409.66 371.639 400.724 375.345 382.177 342.638 395.367 337.169 409.66 371.639", fill: "#ffb6b6" }),
    import_react10.default.createElement("path", { d: "M654.666,605.10608l-27.4814,11.39569-.14413-.34754a11.58034,11.58034,0,0,1,6.26051-15.13212l.00066-.00027,3.44042-5.89,10.94532-.07527,2.39894-.99477Z", transform: "translate(-240.82477 -224.27489)", fill: "#2f2e41" }),
    import_react10.default.createElement("path", { d: "M703.60706,429.88431,634.949,437.05755l-9.18415,30.9327L593.959,519.10356s22.19352,37.35431,20.10975,36.9474,2.08141,9.77544,4.99882,9.18427,5.95114,6.048,3.93428,7.22839,6.075,11.16148,6.075,11.16148l12.36745-11.10062c2.63064-19.84259-.54767-37.5025-11.87134-52.10187l35.43311-38.25276,6.71872-2.78791h0l5.33346,141.94681,19.72672.324c5.44319-28.001,8.17765-53.20264,3.92306-71.181,0,0,.61121-54.00878,2.9441-53.41821s.35522-6.44533.35522-6.44533-2.04311-5.99228.46727-8.47819.94283-17.10681.94283-17.10681C709.56529,451.18649,708.31675,439.76183,703.60706,429.88431Z", transform: "translate(-240.82477 -224.27489)", fill: "#2f2e41" }),
    import_react10.default.createElement("path", { d: "M650.81656,315.73317l18.9806-4.91844,8.86-12.22,21.0413,2.58668,4.47906,16.66817,14.9797,8.69511s-8.27947,87.57154-6.31006,92.38,9.03083,4.41151,3.00012,10.61-6.82952,3.70179-5.43011,10.45013,11.60059,13.89007,0,13.81921-81.6006-1.07087-79.6006-9.07087,1.96851-5.9685,4.98426-10.98425,5.0454-2.21287,4.03057-9.61431-.01483-12.40144-.01483-16.40144,3.3506-40.34856,3.3506-40.34856Z", transform: "translate(-240.82477 -224.27489)", fill: "#e6e6e6" }),
    import_react10.default.createElement("circle", { cx: "448.30022", cy: "49.76351", r: "22.29759", fill: "#ffb6b6" }),
    import_react10.default.createElement("path", { d: "M665.761,260.54392c1.9577,1.58218,1.5097,9.27681,3.69127,8.02262s2.63553-3.50015,5.1476-3.5237a8.22527,8.22527,0,0,1,5.41668,2.4512c.26741.24165.52174.495.76872.74549.226-.07921.449-.151.68382-.20986a7.08488,7.08488,0,0,1,5.19618.73165,6.95153,6.95153,0,0,0-3.95779,1.59587c.47948.53741.96621,1.07776,1.47774,1.57719,4.27031,4.18489,13.02635-.27172,18.91376-1.27734-4.90352,5.354-3.93673,8.34287-2.71726,15.49909l.0051.39093c.25083-1.65034,5.53628-1.56808,4.665.62174a28.15028,28.15028,0,0,1-4.07379,5.98859c7.20187-4.98919,13.01589-11.86644,14.30056-20.17385.26377-1.7467.77842-3.52883.28077-5.23186a4.01217,4.01217,0,0,0-3.832-3.05507A14.78354,14.78354,0,0,0,693.54552,246.048a56.49984,56.49984,0,0,0-6.83938,2.952,12.29375,12.29375,0,0,1-7.24377,1.2269c-1.54693-.31955-3.11368-1.12051-4.63-.667-1.75693.52692-2.51211,2.38246-3.21641,4.17371a7.07691,7.07691,0,0,1,3.29711,2.48709,6.92471,6.92471,0,0,0-4.26009-.1731.43242.43242,0,0,0-.07579.02057C668.98635,258.91875,668.89427,259.61774,665.761,260.54392Z", transform: "translate(-240.82477 -224.27489)", fill: "#2f2e41" }),
    import_react10.default.createElement("path", { d: "M673.11347,304.84175c-11.42071-.91945-21.84882,7.81481-26.60321,18.23948s-5.06584,22.25071-5.29663,33.70605l-.71739,35.60854c-.10616,5.26925-.21234,10.53942-.47487,15.80318a77.26919,77.26919,0,0,1-1.92322,15.2123c-2.32856,9.16483-7.45061,17.33176-12.49784,25.32813a342.46661,342.46661,0,0,0,39.35687,9.39941c6.63833-21.47143,13.3526-43.55978,11.72065-65.97466-.86356-11.8611-4.05373-23.44151-5.26637-35.272-1.71744-16.75527.55885-33.634,2.83092-50.32311", transform: "translate(-240.82477 -224.27489)", fill: "#3f3d56" }),
    import_react10.default.createElement("path", { d: "M700.836,306.8445c11.31237,1.81894,19.36805,12.77972,21.51088,24.03522s-.36294,22.81721-2.85906,33.99967q-3.87954,17.38016-7.7591,34.76031c-1.14817,5.14373-2.29652,10.28836-3.29149,15.4639-.96657,5.02779,3.08172,11.47615,3.12806,16.59579.08557,9.45564-1.75062,17.24335,1.25333,26.20954a342.46592,342.46592,0,0,1-40.46314-.21555c-1.34962-22.43364-2.62649-45.48459,4.28164-66.87074,3.65552-11.31675,9.50443-21.80833,13.49178-33.01246,5.6472-15.86815,7.44422-32.80461,9.2003-49.55587", transform: "translate(-240.82477 -224.27489)", fill: "#3f3d56" }),
    import_react10.default.createElement("path", { d: "M708.37724,468.4959a6.48017,6.48017,0,0,1,2.2432-8.75562,6.21606,6.21606,0,0,1,.92551-.44679l-1.44243-49.11577,15.62627-3.97739L719.771,463.42225a6.4622,6.4622,0,0,1-2.82961,7.36445,6.18428,6.18428,0,0,1-8.47911-2.14374Q708.41874,468.57,708.37724,468.4959Z", transform: "translate(-240.82477 -224.27489)", fill: "#ffb6b6" }),
    import_react10.default.createElement("path", { d: "M707.2365,326.4663s10.90751-9.22413,20.0858,9.21932,4.04923,60.57764,2.75719,62.82636-2.08039-.88383-1.37283,5.1103c.57547,4.875-2.84614,4.26527-1.61876,5.30556,3.2365,2.74318-5.8266,3.05552-1.172,5.47258s-16.17825,2.86969-16.17825,2.86969-2.51965-1.7996-.76967-8.58563c.9829-3.81144,3.44377-5.20575.819-6.96947s2.71136-7.21624,2.715-8.41264-8.32057-27.36332-8.32057-27.36332Z", transform: "translate(-240.82477 -224.27489)", fill: "#3f3d56" }),
    import_react10.default.createElement("path", { d: "M616.97678,553.67405a18.37353,18.37353,0,0,1-14.70157-7.353l-45.07543-60.10157a18.37838,18.37838,0,1,1,29.40612-22.0531l29.48989,39.31685,75.741-113.61a18.37915,18.37915,0,1,1,30.58476,20.38984l-90.15086,135.2263a18.38665,18.38665,0,0,1-14.78234,8.17867C617.3178,553.67105,617.14729,553.67405,616.97678,553.67405Z", transform: "translate(-240.82477 -224.27489)", fill: "#389e0d" }),
    import_react10.default.createElement("path", { d: "M651.33681,459.96439a6.48015,6.48015,0,0,0-1.75587-8.86621,6.21784,6.21784,0,0,0-.89941-.49726l4.1547-48.961L637.45366,396.805l2.78725,57.46379a6.46219,6.46219,0,0,0,2.41828,7.50958,6.18429,6.18429,0,0,0,8.58463-1.67185Q651.29128,460.0361,651.33681,459.96439Z", transform: "translate(-240.82477 -224.27489)", fill: "#ffb6b6" }),
    import_react10.default.createElement("path", { d: "M660.3391,318.31573s-10.381-9.81286-20.56461,8.09515-7.391,60.26128-6.22519,62.578,2.12606-.7675,1.0883,5.17836c-.844,4.8358,2.60606,4.41605,1.32307,5.38692-3.38316,2.56012,5.64883,3.37286.8677,5.529s15.99493,3.75942,15.99493,3.75942,2.61526-1.65759,1.243-8.53c-.77075-3.85993-3.1508-5.38811-.43259-7.00407s-2.3084-7.35506-2.24591-8.54984,9.82013-26.86165,9.82013-26.86165Z", transform: "translate(-240.82477 -224.27489)", fill: "#3f3d56" })
  );
};

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/SummaryCard.js
var import_react14 = __toESM(require_react());

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/hooks/useBrandSummaryData.js
var useBrandSummaryData = function() {
  var _a2 = useSWR("".concat(window.location.origin, "/brand/brand.summary.json"), getBrandSummaryJson, swrConfig), data = _a2.data, error = _a2.error;
  return {
    data,
    error,
    pending: !data && !error
  };
};
var useBrandSummaryData_default = useBrandSummaryData;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/hooks/useCalculation.js
var import_react11 = __toESM(require_react());
var __awaiter4 = function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator4 = function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var useCalculation = function(_a2) {
  var baseUrl = _a2.baseUrl, token = _a2.token, setCalculation = _a2.setCalculation, setCalculationPending = _a2.setCalculationPending, electricity = _a2.electricity, gas = _a2.gas;
  var calculate = (0, import_react11.useCallback)(function() {
    return __awaiter4(void 0, void 0, void 0, function() {
      var calculation, e_1;
      return __generator4(this, function(_a3) {
        switch (_a3.label) {
          case 0:
            _a3.trys.push([0, 2, 3, 4]);
            setCalculationPending(true);
            return [4, getCalculation(token, "".concat(baseUrl, "/api/signup/calculation?electricity=").concat(electricity, "&gas=").concat(gas))];
          case 1:
            calculation = _a3.sent();
            setCalculation(calculation);
            return [3, 4];
          case 2:
            e_1 = _a3.sent();
            console.error(e_1);
            return [3, 4];
          case 3:
            setCalculationPending(false);
            return [
              7
              /*endfinally*/
            ];
          case 4:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, [baseUrl, token, electricity, gas, setCalculation, setCalculationPending]);
  return {
    calculate
  };
};
var useCalculation_default = useCalculation;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/SummaryCardInfo.js
var import_react12 = __toESM(require_react());
var __makeTemplateObject8 = function(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", { value: raw });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read2 = function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
      ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"]))
        m.call(i);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var InfoTitle = styled_components_browser_esm_default.span(templateObject_18 || (templateObject_18 = __makeTemplateObject8(["\n  cursor: pointer;\n  &:hover {\n    text-decoration: underline;\n  }\n"], ["\n  cursor: pointer;\n  &:hover {\n    text-decoration: underline;\n  }\n"])));
var SummaryCardInfo = function(_a2) {
  var icon = _a2.icon, shortDescription = _a2.shortDescription, title = _a2.title, description = _a2.description;
  var _b2 = __read2((0, import_react12.useState)(false), 2), visible = _b2[0], setVisible = _b2[1];
  return import_react12.default.createElement(
    import_react12.default.Fragment,
    null,
    icon,
    " ",
    description ? import_react12.default.createElement(InfoTitle, { onClick: function() {
      return setVisible(true);
    } }, shortDescription) : import_react12.default.createElement("span", null, shortDescription),
    description && import_react12.default.createElement(modal_default, { title, open: visible, onCancel: function() {
      return setVisible(false);
    }, footer: null }, description)
  );
};
var SummaryCardInfo_default = SummaryCardInfo;
var templateObject_18;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/SummaryIcon.js
var import_react13 = __toESM(require_react());
var __makeTemplateObject9 = function(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", { value: raw });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var IconContianer = styled_components_browser_esm_default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject9(["\n  display: inline-flex;\n  margin-right: 8px;\n  color: ", ";\n"], ["\n  display: inline-flex;\n  margin-right: 8px;\n  color: ", ";\n"])), function(props) {
  return props.color || "black";
});
var SummaryIcon = function(_a2) {
  var _b2 = _a2.type, type = _b2 === void 0 ? "Check" : _b2;
  switch (type.toLowerCase()) {
    case "fund":
      return import_react13.default.createElement(
        IconContianer,
        { color: "#531dab" },
        import_react13.default.createElement(FundOutlined_default, null)
      );
    case "eurocircle":
      return import_react13.default.createElement(
        IconContianer,
        { color: "#d46b08" },
        import_react13.default.createElement(EuroCircleOutlined_default, null)
      );
    case "thunder":
      return import_react13.default.createElement(
        IconContianer,
        { color: "#389e0d" },
        import_react13.default.createElement(ThunderboltOutlined_default, null)
      );
    case "fire":
      return import_react13.default.createElement(
        IconContianer,
        { color: "#096dd9" },
        import_react13.default.createElement(FireOutlined_default, null)
      );
    case "checkcircle":
      return import_react13.default.createElement(
        IconContianer,
        { color: "#08979c" },
        import_react13.default.createElement(CheckCircleOutlined_default, null)
      );
    case "check":
    default:
      return import_react13.default.createElement(
        IconContianer,
        { color: "#d46b08" },
        import_react13.default.createElement(CheckOutlined_default, null)
      );
  }
};
var SummaryIcon_default = SummaryIcon;
var templateObject_19;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/elements/SummaryCard.js
var __makeTemplateObject10 = function(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", { value: raw });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read3 = function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
      ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"]))
        m.call(i);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var ListItem = styled_components_browser_esm_default(list_default.Item)(templateObject_110 || (templateObject_110 = __makeTemplateObject10(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n"])));
var Title = styled_components_browser_esm_default(typography_default.Title)(templateObject_2 || (templateObject_2 = __makeTemplateObject10(["\n  margin: 12px 0;\n  display: flex;\n  align-items: center;\n  span {\n    margin-left: auto;\n  }\n"], ["\n  margin: 12px 0;\n  display: flex;\n  align-items: center;\n  span {\n    margin-left: auto;\n  }\n"])));
var Container = styled_components_browser_esm_default(SignUpFlowAlertContainer_default)(templateObject_3 || (templateObject_3 = __makeTemplateObject10(["\n  margin: 12px 0;\n"], ["\n  margin: 12px 0;\n"])));
var SmallCard = styled_components_browser_esm_default(Card_default)(templateObject_4 || (templateObject_4 = __makeTemplateObject10(["\n  margin-top: 24px;\n  width: 450px;\n  .ant-card-body {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    > button {\n      margin: 24px 0;\n    }\n  }\n"], ["\n  margin-top: 24px;\n  width: 450px;\n  .ant-card-body {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    > button {\n      margin: 24px 0;\n    }\n  }\n"])));
var SummaryCard = function(_a2) {
  var _b2, _c2;
  var baseUrl = _a2.baseUrl, _d2 = _a2.token, token = _d2 === void 0 ? "" : _d2, _e2 = _a2.electricity, electricity = _e2 === void 0 ? 0 : _e2, _f2 = _a2.gas, gas = _f2 === void 0 ? 0 : _f2, language = _a2.language;
  var data = useBrandSummaryData_default().data;
  var _g = __read3((0, import_react14.useState)(false), 2), visible = _g[0], setVisible = _g[1];
  var _h = __read3((0, import_react14.useState)(null), 2), calculation = _h[0], setCalculation = _h[1];
  var _j = __read3((0, import_react14.useState)(false), 2), calculationPending = _j[0], setCalculationPending = _j[1];
  var currencyFormatter = useNumber_default({ language }).currencyFormatter;
  var calculate = useCalculation_default({ baseUrl, token, setCalculation, setCalculationPending, gas, electricity }).calculate;
  (0, import_react14.useEffect)(function() {
    if (electricity > 0 || gas > 0) {
      calculate();
    }
  }, [electricity, gas, calculate]);
  return import_react14.default.createElement(
    SmallCard,
    null,
    import_react14.default.createElement(SectionTitle_default, null, translations[language].yourPersonalOffer),
    import_react14.default.createElement(
      list_default,
      { size: "small" },
      data && ((_b2 = data === null || data === void 0 ? void 0 : data.top) === null || _b2 === void 0 ? void 0 : _b2[language].map(function(item, index) {
        return import_react14.default.createElement(
          ListItem,
          { key: index },
          import_react14.default.createElement(SummaryCardInfo_default, { icon: import_react14.default.createElement(SummaryIcon_default, { type: item.icon }), shortDescription: item.shortDescription, title: item.title, description: import_react14.default.createElement("div", { dangerouslySetInnerHTML: { __html: item.description } }) })
        );
      })),
      calculationPending ? import_react14.default.createElement(Loader_default, { small: true }) : import_react14.default.createElement(
        import_react14.default.Fragment,
        null,
        electricity > 0 && import_react14.default.createElement(
          ListItem,
          null,
          import_react14.default.createElement(SummaryCardInfo_default, { icon: import_react14.default.createElement(SummaryIcon_default, { type: "Thunder" }), shortDescription: "".concat(translations[language].power, ": ").concat(electricity, " kWh · ").concat(translations[language].avg, " ").concat(currencyFormatter.format((calculation === null || calculation === void 0 ? void 0 : calculation.averageElectricity) || 0), " / kWh") })
        ),
        gas > 0 && import_react14.default.createElement(
          ListItem,
          null,
          import_react14.default.createElement(SummaryCardInfo_default, { icon: import_react14.default.createElement(SummaryIcon_default, { type: "Fire" }), shortDescription: "".concat(translations[language].gas, ": ").concat(gas, " m³ · ").concat(translations[language].avg, "  ").concat(currencyFormatter.format((calculation === null || calculation === void 0 ? void 0 : calculation.averageGas) || 0), " / m³") })
        )
      )
    ),
    import_react14.default.createElement(
      Container,
      null,
      import_react14.default.createElement(alert_default, { message: translations[language].youCanLeaveAnyTime, type: "warning" })
    ),
    calculationPending ? import_react14.default.createElement(Loader_default, { small: true }) : (electricity > 0 || gas > 0) && import_react14.default.createElement(
      import_react14.default.Fragment,
      null,
      import_react14.default.createElement(
        Title,
        { level: 4 },
        translations[language].averagePerMonth,
        " ",
        import_react14.default.createElement("span", null, currencyFormatter.format((calculation === null || calculation === void 0 ? void 0 : calculation.averagePerMonth) || 0))
      ),
      import_react14.default.createElement(
        Title,
        { level: 5 },
        translations[language].expectedCostsPerYear,
        " ",
        import_react14.default.createElement("span", null, currencyFormatter.format((calculation === null || calculation === void 0 ? void 0 : calculation.costPerYear) || 0))
      )
    ),
    import_react14.default.createElement(button_default, { size: "large", onClick: function(e) {
      e.preventDefault();
      setVisible(true);
    }, loading: calculationPending, disabled: electricity === 0 && gas === 0 }, translations[language].priceStructureAndCosts),
    (data === null || data === void 0 ? void 0 : data.main[language]) && import_react14.default.createElement(
      modal_default,
      { title: data === null || data === void 0 ? void 0 : data.main[language].title, open: visible, onCancel: function() {
        return setVisible(false);
      }, footer: null },
      import_react14.default.createElement("div", { dangerouslySetInnerHTML: { __html: data === null || data === void 0 ? void 0 : data.main[language].description } })
    ),
    import_react14.default.createElement(list_default, { size: "small" }, data && ((_c2 = data === null || data === void 0 ? void 0 : data.bottom) === null || _c2 === void 0 ? void 0 : _c2[language].map(function(item, index) {
      return import_react14.default.createElement(
        ListItem,
        { key: index },
        import_react14.default.createElement(SummaryCardInfo_default, { icon: import_react14.default.createElement(SummaryIcon_default, null), shortDescription: item.shortDescription, title: item.title, description: import_react14.default.createElement("div", { dangerouslySetInnerHTML: { __html: item.description } }) })
      );
    })))
  );
};
var SummaryCard_default = SummaryCard;
var templateObject_110;
var templateObject_2;
var templateObject_3;
var templateObject_4;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/hooks/useAccessToken.js
var import_react15 = __toESM(require_react());
var __awaiter5 = function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator5 = function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var __read4 = function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
      ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"]))
        m.call(i);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var useAccessToken = function(_a2) {
  var baseUrl = _a2.baseUrl;
  var _b2 = __read4((0, import_react15.useState)(), 2), generatedHash = _b2[0], setGeneratedHash = _b2[1];
  var _c2 = useSWR(generatedHash ? "".concat(baseUrl, "/api/signup/token?h=").concat(generatedHash) : null, getAccessToken, swrConfig), data = _c2.data, error = _c2.error;
  (0, import_react15.useEffect)(function() {
    var getHash = function() {
      return __awaiter5(void 0, void 0, void 0, function() {
        var _a3;
        return __generator5(this, function(_b3) {
          switch (_b3.label) {
            case 0:
              _a3 = setGeneratedHash;
              return [4, hash()];
            case 1:
              return [2, _a3.apply(void 0, [_b3.sent()])];
          }
        });
      });
    };
    getHash();
  }, []);
  return {
    token: data === null || data === void 0 ? void 0 : data.result,
    error,
    pending: !data && !error
  };
};
var useAccessToken_default = useAccessToken;

// node_modules/@myportal/ecedo-myportal-frontend-components/components/SignUpFlow/index.js
var __makeTemplateObject11 = function(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", { value: raw });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign2 = function() {
  __assign2 = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign2.apply(this, arguments);
};
var __awaiter6 = function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator6 = function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var __read5 = function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
      ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"]))
        m.call(i);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var SummaryCol = styled_components_browser_esm_default(col_default)(templateObject_111 || (templateObject_111 = __makeTemplateObject11(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var SuccessCard = styled_components_browser_esm_default(Card_default)(templateObject_22 || (templateObject_22 = __makeTemplateObject11(["\n  .ant-card-body {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 700px;\n    h2 {\n      color: #389e0d;\n    }\n  }\n"], ["\n  .ant-card-body {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 700px;\n    h2 {\n      color: #389e0d;\n    }\n  }\n"])));
var SuccessIconContainer = styled_components_browser_esm_default.div(templateObject_32 || (templateObject_32 = __makeTemplateObject11(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 400px;\n  margin-bottom: 24px;\n  svg {\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 400px;\n  margin-bottom: 24px;\n  svg {\n    width: 100%;\n    height: 100%;\n  }\n"])));
var SignUpFlow = function(_a2) {
  var baseUrl = _a2.baseUrl, _b2 = _a2.language, language = _b2 === void 0 ? "nl" : _b2;
  var _c2 = useAccessToken_default({ baseUrl }), token = _c2.token, error = _c2.error, pending = _c2.pending;
  var _d2 = __read5(form_default.useForm(), 1), offerForm = _d2[0];
  var _e2 = __read5(form_default.useForm(), 1), applyForm = _e2[0];
  var _f2 = __read5((0, import_react16.useState)(), 2), offerFormState = _f2[0], setOfferFormState = _f2[1];
  var _g = __read5((0, import_react16.useState)(false), 2), formSuccess = _g[0], setFormSuccess = _g[1];
  var _h = __read5((0, import_react16.useState)(false), 2), formPending = _h[0], setFormPending = _h[1];
  var _j = __read5((0, import_react16.useState)(0), 2), selected = _j[0], setSelected = _j[1];
  var _k = __read5((0, import_react16.useState)(true), 2), disabled = _k[0], setDisabled = _k[1];
  var _l = __read5((0, import_react16.useState)(null), 2), address = _l[0], setAddress = _l[1];
  var _m = __read5((0, import_react16.useState)(false), 2), addressPending = _m[0], setAddressPending = _m[1];
  var _o = __read5((0, import_react16.useState)([]), 2), eans = _o[0], setEans = _o[1];
  var _p = __read5((0, import_react16.useState)(0), 2), electricity = _p[0], setElectricity = _p[1];
  var _q = __read5((0, import_react16.useState)(0), 2), gas = _q[0], setGas = _q[1];
  var _r = __read5((0, import_react16.useState)(false), 2), multipleEAN = _r[0], setMultipleEAN = _r[1];
  var _s = __read5((0, import_react16.useState)(false), 1), showMultipleEANForm = _s[0];
  var _t = __read5((0, import_react16.useState)([]), 2), selectedEANList = _t[0], setSelectedEANList = _t[1];
  (0, import_react16.useEffect)(function() {
    setElectricity(selectedEANList.filter(function(item) {
      return item.type === ProductType.ELECTRICITY;
    }).reduce(function(prev, curr) {
      return prev + curr.value;
    }, 0));
    setGas(selectedEANList.filter(function(item) {
      return item.type === ProductType.GAS;
    }).reduce(function(prev, curr) {
      return prev + curr.value;
    }, 0));
  }, [setElectricity, setGas, selectedEANList]);
  return import_react16.default.createElement(
    row_default,
    { gutter: [16, 24] },
    import_react16.default.createElement(
      col_default,
      { md: 12 },
      import_react16.default.createElement(spin_default, { spinning: pending }, formSuccess ? import_react16.default.createElement(
        SuccessCard,
        null,
        import_react16.default.createElement(
          SuccessIconContainer,
          null,
          import_react16.default.createElement(SuccessIcon, null)
        ),
        import_react16.default.createElement(SectionTitle_default, null, translations[language].signedUpSuccess),
        import_react16.default.createElement(button_default, { onClick: function(e) {
          e.preventDefault();
          offerForm.resetFields();
          applyForm.resetFields();
          setOfferFormState(void 0);
          setAddress(null);
          setEans([]);
          setSelected(0);
          setDisabled(true);
          setElectricity(0);
          setGas(0);
          setFormSuccess(false);
        } }, translations[language].createNew)
      ) : import_react16.default.createElement(
        Card_default,
        { actions: [
          import_react16.default.createElement(button_default, { key: "back", onClick: function() {
            setSelected(function(state) {
              return state === 0 ? state : state - 1;
            });
          }, disabled: selected === 0 || formPending }, translations[language].back),
          import_react16.default.createElement(button_default, { key: "next", type: "primary", loading: formPending, onClick: function() {
            return __awaiter6(void 0, void 0, void 0, function() {
              var e_1;
              return __generator6(this, function(_a3) {
                switch (_a3.label) {
                  case 0:
                    _a3.trys.push([0, 6, 7, 8]);
                    if (!(selected === 0))
                      return [3, 2];
                    return [4, offerForm.validateFields()];
                  case 1:
                    _a3.sent();
                    setOfferFormState(offerForm.getFieldsValue());
                    setSelected(1);
                    _a3.label = 2;
                  case 2:
                    if (!(selected === 1 && token))
                      return [3, 5];
                    setFormPending(true);
                    return [4, applyForm.validateFields()];
                  case 3:
                    _a3.sent();
                    return [4, postSignUp(token, "".concat(baseUrl, "/api/signup"), __assign2(__assign2({}, offerFormState), applyForm.getFieldsValue()))];
                  case 4:
                    _a3.sent();
                    setFormSuccess(true);
                    window.scrollTo(0, 0);
                    _a3.label = 5;
                  case 5:
                    return [3, 8];
                  case 6:
                    e_1 = _a3.sent();
                    console.error(e_1);
                    notification_default.error({
                      message: translations[language].notificationErrorTitle,
                      description: translations[language][e_1.message]
                    });
                    return [3, 8];
                  case 7:
                    setFormPending(false);
                    return [
                      7
                      /*endfinally*/
                    ];
                  case 8:
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          }, disabled: disabled || multipleEAN }, translations[language].next)
        ] },
        import_react16.default.createElement(SectionTitle_default, null, translations[language].calculateYourOffer),
        error && import_react16.default.createElement(
          SignUpFlowAlertContainer_default,
          null,
          import_react16.default.createElement(Alert_default, { message: translations[language].serverError, type: "error" })
        ),
        selected === 0 && import_react16.default.createElement(OfferForm_default, { baseUrl, token, address, setAddress, addressPending, setAddressPending, setElectricity, setGas, disabled, disabledAddress: !!error, setDisabled, form: offerForm, language, multipleEAN, setMultipleEAN, showMultipleEANForm, selectedEANList, setSelectedEANList, eans, setEans }),
        selected === 1 && import_react16.default.createElement(ApplyForm_default, { language, form: applyForm })
      ))
    ),
    import_react16.default.createElement(
      SummaryCol,
      { md: 12 },
      import_react16.default.createElement(
        affix_default,
        null,
        import_react16.default.createElement(SummaryCard_default, { baseUrl, token, electricity, gas, language })
      )
    )
  );
};
var SignUpFlow_default = SignUpFlow;
var templateObject_111;
var templateObject_22;
var templateObject_32;
export {
  SignUpFlow_default as default
};
//# sourceMappingURL=@myportal_ecedo-myportal-frontend-components_components_SignUpFlow.js.map
